import ContactLensImageTypeSwitcherFloat from '@/components/organisms/item-list/ContactLensImageTypeSwitcherFloat.vue'
import { ItemKind } from '@/models/item/kind'
import Vue from 'vue'

import ItemListHeaderBar from '@ajax/vue/components/templates/ItemListHeaderBar.vue'

/**
 * itemKind 等に応じた商品一覧ヘッダー追加コンポーネントを返すビルダー
 * （ list-header スロットに差し込まれるコンポーネント全般を指す）
 */
export default class ItemListHeaderAddonBuilder {
  static create(
    itemKind: ItemKind,
    displayLevelOfImageToDisplay: number | null,
    showItemListHeaderBar: boolean
  ): ItemListHeaderAddonBuilder {
    return new ItemListHeaderAddonBuilder(itemKind, displayLevelOfImageToDisplay, showItemListHeaderBar)
  }

  private constructor(
    private itemKind: ItemKind,
    private displayLevelOfImageToDisplay: number | null,
    private showItemListHeaderBar: boolean
  ) {}

  // 追加コンポーネントを返す。表示しない場合は null を返す
  build(): typeof Vue | null {
    // /itemlist と /itemlist/search では絞り込み・ソート・画像切替ボタンを統合した ItemListHeaderBar を常に表示
    if (this.showItemListHeaderBar) {
      return ItemListHeaderBar
    }

    // displayLevelOfImageToDisplay が指定されている場合は外部指定が優先されるため非表示
    if (this.itemKind === 'contact-lens' && this.displayLevelOfImageToDisplay === null) {
      return ContactLensImageTypeSwitcherFloat
    }

    return null
  }
}
